module.exports = __webpack_public_path__ + "static/media/E_01_WIN.ae7050bf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/E_01_WIN.mp3
// module id = 121
// module chunks = 0